import React from 'react';
import { Box, Typography, TextField, IconButton, Paper, InputAdornment } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import styles from './ChatbotUI/ChatbotUI_styles';

function SSOErrorPage() {
    return (
        <Box sx={styles.mainContainer}>
            <Paper elevation={3} sx={styles.chatContainer}>
                <Box sx={styles.messageArea}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'Noto Sans',
                                fontSize: '14px',
                                fontWeight: 400,
                                lineHeight: '20px',
                                textAlign: 'center',
                                color: '#999999',
                            }}
                        >
                            連線已過期，請重新整理頁面
                        </Typography>
                    </Box>
                </Box>
                <Box sx={styles.inputArea}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="請輸入您的問題，我將為您提供最相關的參考文章"
                        disabled
                        sx={styles.inputField}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        disabled
                                        sx={{
                                            ...styles.sendButton,
                                            marginRight: '10px',
                                            color: '#CCCCCC',
                                        }}
                                    >
                                        <SendIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </Paper>
        </Box>
    );
}

export default SSOErrorPage;
